import { SECTION_LABEL_CLASS, DETAIL_CLASS } from './financial.type.component';

export default function FinancialSectionHeader({ section }) {
    return (
        <header className="mb-3 flex items-start justify-between gap-3">
            <div>
                <p className={['m-0', SECTION_LABEL_CLASS].join(' ')} style={{ color: section.captionColor }}>
                    {section.label}
                </p>

                <p className={['m-0 mt-1', DETAIL_CLASS].join(' ')}>{section.description}</p>
            </div>

            {section.action || null}
        </header>
    );
}
